// extracted by mini-css-extract-plugin
export var deleteIcon = "_uk-5";
export var deleteOption = "_uk-3";
export var divider = "_uk-2";
export var downloadIcon = "_uk-4";
export var drawer = "_uk-0";
export var drawerFooter = "_uk-6";
export var drawerOpen = "_uk-1";
export var highlighted = "_uk-7";
export var lighterHighlight = "_uk-8";